import { render, staticRenderFns } from "./total-student-grade.vue?vue&type=template&id=f9334a60&scoped=true"
import script from "./total-student-grade.vue?vue&type=script&lang=js"
export * from "./total-student-grade.vue?vue&type=script&lang=js"
import style0 from "./total-student-grade.vue?vue&type=style&index=0&id=f9334a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9334a60",
  null
  
)

export default component.exports